
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"currentColor","viewBox":"0 0 21 21","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M4.151 2h12.197a1.25 1.25 0 011.22.979l.914 4.108.018.163a2.25 2.25 0 01-3.736 1.69l-.014-.014-.154.127a2.238 2.238 0 01-1.192.442l-.154.005c-.57 0-1.09-.212-1.486-.56l-.014-.014-.154.127a2.238 2.238 0 01-1.192.442l-.154.005c-.57 0-1.09-.212-1.486-.56l-.014-.014-.154.127a2.239 2.239 0 01-1.192.442L7.25 9.5c-.57 0-1.09-.212-1.486-.56l-.014-.014-.154.127a2.239 2.239 0 01-1.192.442L4.25 9.5A2.25 2.25 0 012 7.25l.018-.163.913-4.11A1.25 1.25 0 014.15 2zm12.844 5.315l-.847-3.816H4.35l-.846 3.815.003.038a.75.75 0 00.641.641L4.25 8A.75.75 0 005 7.25l.008-.12c.114-.878 1.492-.838 1.492.12l.007.102A.75.75 0 008 7.25l.008-.12c.114-.878 1.492-.838 1.492.12l.007.102A.75.75 0 0011 7.25l.008-.12c.114-.878 1.492-.838 1.492.12l.007.102A.75.75 0 0014 7.25l.008-.12c.114-.878 1.492-.838 1.492.12l.007.102A.75.75 0 0017 7.25l-.005.065zm.498 3.333A.75.75 0 0016 10.75v6l-.007.057a.25.25 0 01-.243.193H13v-6.25l-.007-.102a.75.75 0 00-1.493.102V13h-7v-2.25l-.007-.102A.75.75 0 003 10.75v6l.006.143A1.75 1.75 0 004.75 18.5h11l.143-.006A1.75 1.75 0 0017.5 16.75v-6l-.007-.102zM11.5 17v-2.5h-7v2.25a.25.25 0 00.193.243L4.75 17h6.75z"}})])
          )
        }
      }
    